/**
 * @fileoverview GET handler for the "/companies/:company_id/time_zone_options" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { timezoneOptionsCacheKey } from "./constants";
import type { CompanyTimezoneOptionsResult } from "./types";

export const getCompanyTimezoneOptions = reactQueryFetcherAdapter(
  timezoneOptionsCacheKey,
  (signal: AbortSignal, companyId: string): Promise<CompanyTimezoneOptionsResult> => {
    return fetch(`/companies/${companyId}/time_zone_options`, "GET", {}, { signal });
  }
);
